export default "__VITE_ASSET__a9a98135__"